// Plateo mascot ("Platypus") — animated, dependency-free.
//
//   import { createPlateoMascot } from './plateoMascot';
//   const m = createPlateoMascot(divElement, { running: false });
//   m.setRunning(true);   // face -> zoom out -> turn -> four legs -> run (loops)
//   m.setRunning(false);  // slows down -> stands up -> turns back -> face -> wink
//   m.destroy();
//
// Also exports iconSVG(size) / ICON_SVG for the static face (sidebar, favicon).

const C = {
  ink: '#0b0f13', fur: '#3b4a56', furHi: '#4a5b69', furLo: '#2f3c46', furFar: '#2a353e',
  hood: '#2c3e50', hoodHi: '#36495d', pocket: '#31435a',
  bill: '#708090', billHi: '#8a99a8', billLo: '#5f6e7d', foot: '#5f6e7d', toe: '#4c5a67',
  white: '#FAFAFA', slate: '#708090', fx: '#708090', dust: '#9fb0c2',
};

const MINI_P = (tx, ty, s) => `
  <g transform="translate(${tx} ${ty}) scale(${s}) translate(-986 -971)">
    <polygon points="798,460 932,460 349,1469 249,1411" fill="${C.white}"/>
    <polygon points="800,829 900,887 510,1562 410,1504" fill="${C.slate}"/>
    <polygon points="1117,381 1723,381 1723,848 971,848 833,769 1643,769 1643,460 1117,460" fill="${C.slate}"/>
  </g>`;

// ---------- front view (600-unit art space) ----------
function frontEye(id, cx, cy, flip, tag) {
  const lidR = cy - 11 + (flip ? 2 : -4), lidL = cy - 11 + (flip ? -4 : 2);
  return `
  <g data-p="${tag}">
    <ellipse cx="${cx}" cy="${cy}" rx="24" ry="25" fill="${C.white}"/>
    <clipPath id="${id}-${tag}"><ellipse cx="${cx}" cy="${cy}" rx="24" ry="25"/></clipPath>
    <g clip-path="url(#${id}-${tag})">
      <circle cx="${cx}" cy="${cy + 2}" r="15" fill="${C.ink}"/>
      <circle cx="${cx + 5}" cy="${cy - 4}" r="5" fill="${C.white}"/>
      <circle cx="${cx - 5}" cy="${cy + 7}" r="2" fill="${C.white}" opacity="0.7"/>
      <polygon points="${cx - 30},${cy - 32} ${cx + 30},${cy - 32} ${cx + 30},${lidR} ${cx - 30},${lidL}" fill="${C.fur}"/>
      <line x1="${cx - 25}" y1="${lidL}" x2="${cx + 25}" y2="${lidR}" stroke="${C.ink}" stroke-width="4" stroke-linecap="round"/>
    </g>
  </g>`;
}

function frontHead(id) {
  return `
    <path d="M 128 560 L 150 430 Q 160 360 220 345 L 380 345 Q 440 360 450 430 L 472 560 Z" fill="${C.hood}"/>
    <polygon points="300,150 390,168 442,226 452,310 428,392 300,428 172,392 148,310 158,226 210,168" fill="${C.fur}"/>
    <polygon points="300,150 390,168 442,226 452,310 428,392 300,428" fill="${C.furHi}" opacity="0.55"/>
    <polygon points="172,392 148,310 158,226 196,300 230,410" fill="${C.furLo}" opacity="0.7"/>
    <polygon points="292,106 310,106 288,160 272,152" fill="${C.white}"/>
    <polygon points="318,120 334,120 316,164 302,158" fill="${C.slate}"/>
    <polygon points="204,226 266,218 268,230 206,240" fill="${C.white}"/>
    <g data-p="browR"><polygon points="332,214 394,206 396,218 334,228" fill="${C.white}"/></g>
    ${frontEye(id, 238, 268, 0, 'eyeL')}
    ${frontEye(id, 362, 268, 1, 'eyeR')}
    <path data-p="winkR" d="M 336 270 L 362 259 L 388 270" fill="none" stroke="${C.white}" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" style="display:none"/>`;
}

function frontBill() {
  return `
    <ellipse cx="300" cy="478" rx="150" ry="22" fill="#000" opacity="0.3"/>
    <path d="M 214 312 L 386 312 Q 404 314 412 336 L 452 396 Q 470 430 444 456 Q 420 474 380 472 L 220 472 Q 180 474 156 456 Q 130 430 148 396 L 188 336 Q 196 314 214 312 Z" fill="${C.bill}"/>
    <path d="M 214 312 L 386 312 Q 404 314 412 336 L 436 372 Q 300 360 164 372 L 188 336 Q 196 314 214 312 Z" fill="${C.billHi}"/>
    <polygon points="270,332 282,332 274,348 262,348" fill="${C.ink}" opacity="0.7"/>
    <polygon points="320,332 332,332 324,348 312,348" fill="${C.ink}" opacity="0.7"/>
    <path d="M 178 434 Q 290 452 400 430 Q 414 426 422 414" fill="none" stroke="${C.billLo}" stroke-width="7" stroke-linecap="round"/>`;
}

function frontBody() {
  return `
    <ellipse cx="300" cy="730" rx="96" ry="20" fill="${C.furLo}"/>
    <path d="M 168 692 Q 146 600 176 476 Q 186 444 230 440 L 370 440 Q 414 444 424 476 Q 454 600 432 692 Q 300 714 168 692 Z" fill="${C.hoodHi}"/>
    <path d="M 222 612 L 378 612 L 396 668 Q 300 682 204 668 Z" fill="${C.pocket}"/>
    <line x1="262" y1="480" x2="256" y2="540" stroke="${C.white}" stroke-opacity="0.8" stroke-width="5" stroke-linecap="round"/>
    <line x1="338" y1="480" x2="344" y2="540" stroke="${C.white}" stroke-opacity="0.8" stroke-width="5" stroke-linecap="round"/>
    ${MINI_P(300, 572, 0.04)}
    <g transform="translate(186 492) rotate(16)"><rect x="-24" y="0" width="48" height="122" rx="24" fill="${C.hood}"/><ellipse cx="0" cy="122" rx="21" ry="17" fill="${C.fur}"/></g>
    <g transform="translate(414 492) rotate(-16)"><rect x="-24" y="0" width="48" height="122" rx="24" fill="${C.hood}"/><ellipse cx="0" cy="122" rx="21" ry="17" fill="${C.fur}"/></g>
    <rect x="222" y="682" width="44" height="42" rx="14" fill="${C.fur}"/>
    <rect x="334" y="682" width="44" height="42" rx="14" fill="${C.fur}"/>
    <path d="M 196 738 Q 196 716 226 714 L 262 714 Q 284 716 282 738 Z" fill="${C.foot}"/>
    <path d="M 318 738 Q 316 716 338 714 L 374 714 Q 404 716 404 738 Z" fill="${C.foot}"/>
    <path d="M 226 724 L 226 738 M 252 724 L 252 738 M 348 724 L 348 738 M 374 724 L 374 738" stroke="${C.toe}" stroke-width="4" stroke-linecap="round"/>`;
}

// ---------- side view (local units, ground y=0, facing right) ----------
function leg(tag, x, color) {
  return `
    <g data-p="${tag}" transform="translate(${x} -28)">
      <rect x="-8" y="-6" width="16" height="28" rx="8" fill="${color}"/>
      <path d="M -8 21 L 12 21 Q 22 23 21 28 L -8 28 Q -11 24 -8 21 Z" fill="${C.foot}"/>
    </g>`;
}

function sideArt(id) {
  return `
    ${leg('legFB', -60, C.furFar)}
    ${leg('legFF', 44, C.furFar)}
    <g data-p="tail" transform="translate(-95 -40)">
      <path d="M 6 -7 C -22 -15 -58 -15 -73 -5 C -80 3 -68 12 -46 10 C -24 8 -8 4 6 4 Z" fill="${C.furLo}"/>
      <path d="M -8 -2 L -62 -3" stroke="${C.fur}" stroke-width="2.5" stroke-linecap="round"/>
    </g>
    <path d="M -102 -46 C -102 -70 -72 -80 -22 -80 L 30 -82 C 62 -82 78 -62 72 -38 C 68 -24 52 -18 30 -18 L -72 -18 C -94 -18 -102 -30 -102 -46 Z" fill="${C.hood}"/>
    <path d="M -98 -54 C -92 -72 -62 -78 -22 -78 L 30 -80 C 56 -80 70 -68 72 -56 Q -10 -64 -98 -54 Z" fill="${C.hoodHi}"/>
    ${MINI_P(-26, -48, 0.02)}
    <line x1="64" y1="-52" x2="61" y2="-34" stroke="${C.white}" stroke-opacity="0.8" stroke-width="2.5" stroke-linecap="round"/>
    <path d="M 22 -76 Q 28 -102 56 -100 L 62 -80 Z" fill="#263646"/>
    <g data-p="head">
    <polygon points="75,-150 83,-150 74,-120 66,-123" fill="${C.white}"/>
    <polygon points="88,-144 95,-144 87,-118 80,-121" fill="${C.slate}"/>
    <polygon points="40,-80 50,-108 76,-124 108,-120 126,-100 126,-74 106,-56 58,-56" fill="${C.fur}"/>
    <polygon points="50,-108 76,-124 108,-120 126,-100 88,-98" fill="${C.furHi}" opacity="0.55"/>
    <polygon points="40,-80 58,-56 80,-60 64,-86" fill="${C.furLo}" opacity="0.8"/>
    <polygon points="86,-112 110,-116 111,-110 87,-106" fill="${C.white}"/>
    <g data-p="eyeS">
      <ellipse cx="98" cy="-93" rx="9" ry="10" fill="${C.white}"/>
      <clipPath id="${id}-eyeS"><ellipse cx="98" cy="-93" rx="9" ry="10"/></clipPath>
      <g clip-path="url(#${id}-eyeS)">
        <circle cx="101" cy="-92" r="6" fill="${C.ink}"/>
        <circle cx="103" cy="-95" r="2" fill="${C.white}"/>
        <polygon points="86,-106 112,-106 112,-97 86,-99" fill="${C.fur}"/>
        <line x1="88" y1="-99" x2="110" y2="-97" stroke="${C.ink}" stroke-width="2" stroke-linecap="round"/>
      </g>
    </g>
    <path d="M 114 -90 L 158 -88 Q 196 -88 198 -75 Q 198 -63 182 -62 L 118 -60 Q 110 -74 114 -90 Z" fill="${C.bill}"/>
    <path d="M 114 -90 L 158 -88 Q 196 -88 198 -76 L 115 -77 Z" fill="${C.billHi}"/>
    <polygon points="168,-87 174,-87 171,-81 165,-81" fill="${C.ink}" opacity="0.7"/>
    <path d="M 115 -74 Q 117 -69 123 -68 Q 152 -66 184 -66" fill="none" stroke="${C.billLo}" stroke-width="3" stroke-linecap="round"/>
    </g>
    ${leg('legNB', -54, C.fur)}
    ${leg('legNF', 50, C.fur)}`;
}

function buildSVG(id) {
  return `
<svg viewBox="0 0 400 400" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style="display:block" aria-hidden="true">
  <g data-p="cam">
    <g data-p="fx">
      <g data-p="dashes" stroke="${C.fx}" stroke-width="3" stroke-linecap="round">
        <line/><line/><line/><line/><line/>
      </g>
      <g data-p="speed" stroke="${C.fx}" stroke-width="3" stroke-linecap="round">
        <line/><line/><line/>
      </g>
      <g data-p="dust" fill="${C.dust}"><circle/><circle/></g>
    </g>
    <ellipse data-p="shadow" cx="200" cy="342" rx="62" ry="7" fill="#000" opacity="0.12"/>
    <g data-p="front">
      <g transform="translate(80 45) scale(0.4)">
        ${frontBody()}
        ${frontHead(id)}
        ${frontBill()}
      </g>
    </g>
    <g data-p="side" style="display:none">
      <g data-p="sideBody">${sideArt(id)}</g>
    </g>
  </g>
</svg>`;
}

// ---------- static icon (face only) ----------
let uid = 0;
export function iconSVG(size = 24, id = 'pmi' + (++uid)) {
  // Cropped to the face + bill so small badges don't leave empty headroom or clip the chin.
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="148 100 304 360" width="${size}" height="${size}" role="img" aria-label="Platypus" style="display:block">
  ${frontHead(id)}
  <path d="M 150 600 L 176 476 Q 186 444 230 440 L 370 440 Q 414 444 424 476 L 450 600 Z" fill="${C.hoodHi}"/>
  ${frontBill()}
</svg>`;
}
export const ICON_SVG = iconSVG(64, 'pmicon');

// ---------- animation ----------
const clamp = (x) => Math.max(0, Math.min(1, x));
const seg = (x, a, b) => clamp((x - a) / (b - a));
const lerp = (a, b, k) => a + (b - a) * k;
const eio = (x) => { x = clamp(x); return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
const eo = (x) => 1 - Math.pow(1 - clamp(x), 3);
const ei = (x) => Math.pow(clamp(x), 2);
const backOut = (x) => { x = clamp(x); const c1 = 1.5, c3 = c1 + 1; return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2); };

export function createPlateoMascot(el, opts = {}) {
  const id = 'pm' + (++uid);
  el.innerHTML = buildSVG(id);
  const q = (n) => el.querySelector(`[data-p="${n}"]`);
  const P = {};
  ['cam', 'front', 'side', 'sideBody', 'shadow', 'tail', 'legNF', 'legNB', 'legFF', 'legFB',
   'eyeL', 'eyeR', 'eyeS', 'head', 'winkR', 'browR', 'dashes', 'speed', 'dust'].forEach((n) => (P[n] = q(n)));
  const dashes = [...P.dashes.children], speeds = [...P.speed.children], dusts = [...P.dust.children];

  const reduce = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const speed = opts.speed || 1;
  const S = { u: 0, target: opts.running ? 1 : 0, phase: 0, clock: 0, blinkT: -1, winkT: -1 };
  let raf = 0, last = 0, blinkTimer = 0, dead = false;

  const setT = (node, t) => node.setAttribute('transform', t);
  const squashY = (node, cx, cy, s) => setT(node, `translate(${cx} ${cy}) scale(1 ${s}) translate(${-cx} ${-cy})`);

  function draw() {
    const { u, phase, clock } = S;
    const zP = eio(seg(u, 0, 0.32));
    const tP = seg(u, 0.32, 0.58);
    const fP = seg(u, 0.58, 0.86);
    const r = eio(seg(u, 0.86, 1));

    // camera: tight on the face -> full body -> framed for the run
    const c = lerp(lerp(2.2, 1, zP), 1.04, eio(fP));
    const fy = lerp(lerp(158, 214, zP), 262, eio(fP));
    setT(P.cam, `translate(200 200) scale(${c}) translate(-200 ${-fy})`);

    // turn: front squashes away, side view grows in, with a little hop
    const hop = -14 * Math.sin(Math.PI * tP);
    const frontOn = tP < 0.5, frontSx = 1 - ei(tP * 2), sideSx = Math.max(0.001, eo((tP - 0.5) * 2));
    P.front.style.display = frontOn ? '' : 'none';
    P.side.style.display = frontOn ? 'none' : '';
    setT(P.front, `translate(200 ${hop}) scale(${Math.max(0.001, frontSx)} 1) translate(-200 0)`);

    // upright (standing on hind legs) -> falls forward onto four legs
    const up = 1 - backOut(fP);
    const rot = -76 * up;
    const bob = -5 * r * Math.abs(Math.sin(phase));
    const pitch = 2.5 * r * Math.sin(2 * phase);
    const X = 186 + 73 * clamp(up);
    setT(P.side, `translate(200 ${hop}) scale(${sideSx} 1) translate(-200 0) translate(${X} 340) scale(0.95)`);
    setT(P.sideBody, `translate(0 ${bob}) rotate(${rot + pitch} -62 -28)`);
    setT(P.head, `rotate(${-rot * 0.9 + 2 * r * Math.sin(2 * phase + 0.6)} 52 -76)`);

    // legs: trot cycle, compensated so hind legs stay planted when upright
    const A = 34 * r * Math.sin(phase);
    const baseB = -rot, baseF = -rot * 0.55;
    setT(P.legNF, `translate(50 -28) rotate(${baseF + A})`);
    setT(P.legFB, `translate(-60 -28) rotate(${baseB + A})`);
    setT(P.legFF, `translate(44 -28) rotate(${baseF - A})`);
    setT(P.legNB, `translate(-54 -28) rotate(${baseB - A})`);
    setT(P.tail, `translate(-95 -40) rotate(${-rot * 0.8 + 9 * r * Math.sin(2 * phase + 1)})`);

    // shadow
    const rx = frontOn ? 62 : lerp(70, 132, 1 - clamp(up));
    P.shadow.setAttribute('rx', rx * (1 + bob / 70));

    // eyes: blink + wink
    const b = S.blinkT >= 0 ? Math.sin(Math.PI * Math.min(1, S.blinkT / 0.18)) : 0;
    const w = S.winkT < 0 ? 0 : S.winkT < 0.1 ? S.winkT / 0.1 : S.winkT < 0.6 ? 1 : clamp(1 - (S.winkT - 0.6) / 0.12);
    squashY(P.eyeL, 238, 268, 1 - 0.92 * b);
    squashY(P.eyeR, 362, 268, 1 - 0.92 * b);
    squashY(P.eyeS, 98, -93, 1 - 0.92 * b);
    P.eyeR.style.display = w > 0.5 ? 'none' : '';
    P.winkR.style.display = w > 0.5 ? '' : 'none';
    setT(P.browR, `translate(0 ${-6 * w})`);

    // motion effects
    dashes.forEach((ln, i) => {
      const k = (clock * 0.9 + i / dashes.length) % 1;
      const x = 410 - k * 440;
      ln.setAttribute('x1', x); ln.setAttribute('x2', x + 26);
      ln.setAttribute('y1', 350); ln.setAttribute('y2', 350);
      ln.setAttribute('stroke-opacity', 0.35 * r);
    });
    const sy = [214, 238, 262];
    speeds.forEach((ln, i) => {
      const k = (clock * 1.7 + i * 0.37) % 1;
      const x = 120 - k * 90;
      ln.setAttribute('x1', x); ln.setAttribute('x2', x + 40 * (1 - k));
      ln.setAttribute('y1', sy[i]); ln.setAttribute('y2', sy[i]);
      ln.setAttribute('stroke-opacity', 0.55 * r * Math.sin(Math.PI * k));
    });
    dusts.forEach((d, i) => {
      const k = ((phase / (2 * Math.PI)) + i * 0.5) % 1;
      d.setAttribute('cx', 130 - k * 46);
      d.setAttribute('cy', 336 - k * 14);
      d.setAttribute('r', 3 + k * 10);
      d.setAttribute('fill-opacity', 0.45 * r * (1 - k));
    });
  }

  function step(dt) {
    const prev = S.u;
    const dur = (S.target > S.u ? 1.5 : 1.2) / speed;
    if (reduce) S.u = S.target;
    else S.u = S.target > S.u ? Math.min(1, S.u + dt / dur) : Math.max(0, S.u - dt / dur);
    const r = eio(seg(S.u, 0.86, 1));
    if (r > 0) {
      const hz = reduce ? 1.2 : 3.1 * speed;
      S.phase += dt * 2 * Math.PI * hz * (0.5 + 0.5 * r);
      S.clock += dt * r * speed * (reduce ? 0.4 : 1);
    }
    if (S.blinkT >= 0 && (S.blinkT += dt) > 0.18) S.blinkT = -1;
    if (S.winkT >= 0 && (S.winkT += dt) > 0.72) S.winkT = -1;
    if (prev > 0.4 && S.u === 0 && S.target === 0 && !reduce) S.winkT = 0;
  }

  const active = () => S.u !== S.target || S.u > 0 || S.blinkT >= 0 || S.winkT >= 0;

  function frame(now) {
    if (dead) return;
    const dt = Math.min(0.05, (now - last) / 1000);
    last = now;
    step(dt);
    draw();
    raf = active() ? requestAnimationFrame(frame) : 0;
  }
  function kick() {
    if (!raf && !dead) { last = performance.now(); raf = requestAnimationFrame(frame); }
  }
  function scheduleBlink() {
    blinkTimer = setTimeout(() => {
      if (dead) return;
      if (!reduce) { S.blinkT = 0; kick(); }
      scheduleBlink();
    }, 3200 + Math.random() * 3000);
  }

  draw();
  scheduleBlink();
  if (S.target) kick();

  return {
    setRunning(on) { S.target = on ? 1 : 0; kick(); },
    wink() { S.winkT = 0; kick(); },
    destroy() { dead = true; cancelAnimationFrame(raf); clearTimeout(blinkTimer); el.innerHTML = ''; },
    // for previews/tests: draw a fixed pose (u 0..1, phase in radians)
    _pose(u, phase = 0, blinkT = -1, winkT = -1) { Object.assign(S, { u, phase, clock: phase / 6, blinkT, winkT }); draw(); },
  };
}
